'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _nextOverlay = require('../../next-overlay/lib/index.js');

var _nextOverlay2 = _interopRequireDefault(_nextOverlay);

var _func = require('../../next-util/lib/func.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var PropTypes = _react2.default.PropTypes,
    Children = _react2.default.Children,
    Popup = _nextOverlay2.default.Popup,
    noop = function noop() {};

var Dropdown = (_temp = _class = function (_React$Component) {
	_inherits(Dropdown, _React$Component);

	function Dropdown(props) {
		_classCallCheck(this, Dropdown);

		var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

		_this.state = {
			visible: props.visible || props.defaultVisible || false
		};
		return _this;
	}

	Dropdown.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if ('visible' in nextProps) {
			this.setState({ visible: nextProps.visible });
		}
	};

	Dropdown.prototype.render = function render() {
		var child = Children.only(this.props.children),
		    content = _react2.default.cloneElement(child, {
			onClick: (0, _func.makeChain)(this.onMenuClick.bind(this), child.props.onClick)
		});

		return _react2.default.createElement(
			Popup,
			_extends({}, this.props, {
				canCloseByOutSideClick: true,
				visible: this.state.visible,
				onVisibleChange: this.onVisibleChange.bind(this)
			}),
			content
		);
	};

	Dropdown.prototype.onMenuClick = function onMenuClick() {
		if (!('visible' in this.props)) {
			this.setState({
				visible: false
			});
		}
		this.props.onVisibleChange(false, 'fromContent');
	};

	Dropdown.prototype.onVisibleChange = function onVisibleChange(visible) {
		if (!('visible' in this.props)) {
			this.setState({ visible: visible });
		}
		this.props.onVisibleChange(visible);
	};

	return Dropdown;
}(_react2.default.Component), _class.propTypes = {
	trigger: PropTypes.any,
	onVisibleChange: PropTypes.func,
	align: PropTypes.string
}, _class.defaultProps = {
	prefix: 'next-',
	onVisibleChange: noop
}, _temp);
Dropdown.displayName = 'Dropdown';
exports.default = Dropdown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@alife/next/lib/_components/@alife/next-dropdown/lib/index.js
// module id = 148
// module chunks = 0 1